import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Box, Grid, Stack } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import { GenerateNewIcon, RefreshIcon } from '../../../../assets/icons';
import { Button } from '../../../../components/buttons';
import { AlertDialog } from '../../../../components/dialogs';
import { Dropdown } from '../../../../components/dropDowns';
import { BasicPopover } from '../../../../components/popover';
import { useWebSocketContext } from '../../../../contexts';
import { DashboardService, END_POINTS } from '../../../../services';
import { ForcedShiftParam } from '../../../../services/SotService';
import { TEXT_CONTENT } from '../../../../utils/constants';
import {
  DATE_FORMAT,
  getUTCDateTime,
  toDisplayDate,
} from '../../../../utils/date';
import { PdfViewerModal } from '../../../pdf';
import { useDashboardContext } from '../../contexts';
import { dashboardActions } from '../../contexts';
import {
  FACILITY_ACTION_TYPES,
  GRAPH_GENERATE_STATUS,
  facilityActions,
  useFacilityContext,
} from '../../contexts/FacilityProvider';
import useGraphApiDataRevalidator from '../../useGraphApiDataRevalidator';
import {
  DashboardTypography,
  ResetTypography,
  StyledDivider,
} from './Toolbar.styled';
import UserParamChooser from './graphParamsController/UserParamChooser';
import { ShiftControllerModal } from './shiftController';

function Toolbar() {
  const {
    dispatch: dashboardDispatch,
    state: dashboardState,
    activeFacilitySnapShot,
  } = useDashboardContext();
  const {
    scenarios: { selected: selectedScenario, isLoading: isScenarioLoading },
  } = dashboardState;
  // const [prevParamVersion, setPrevParamVersion] = useState('');
  // const [currentParamVersion, setCurrentParamVersion] =
  //   useState(selectedParamVersion);
  // if (prevParamVersion !== selectedParamVersion) {
  //   setPrevParamVersion(selectedParamVersion);
  //   setCurrentParamVersion(selectedParamVersion);
  // }

  const {
    dispatch: facilityDispatch,
    state: { selectedFacility, facilityList = [] },
  } = useFacilityContext();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isOpenPdfViewer, setIsOpenPdfViewer] = useState(false);

  const { sendMessage, sessionId } = useWebSocketContext();
  const handleInputParameterSubmit = async (values: any) => {
    const pctCasesAppAuto: any = {};
    const pctCasesAppShared: any = {};
    Object.entries(values?.pctCasesAppAuto || {}).forEach(([key, value]) => {
      if (String(value)?.trim() !== '' && Number(value) > 0) {
        let appAuto = Number(value) / 100;
        pctCasesAppAuto[key] = appAuto;
        pctCasesAppShared[key] = Number((1 - appAuto).toFixed(2));
      }
    });
    let startDate = values?.arrivalCubeData?.[0]
      ? toDisplayDate(values?.arrivalCubeData?.[0], DATE_FORMAT.DATE_YYYY_MM_DD)
      : undefined;
    let endDate = values?.arrivalCubeData?.[0]
      ? toDisplayDate(values?.arrivalCubeData?.[1], DATE_FORMAT.DATE_YYYY_MM_DD)
      : undefined;
    const changedShiftsParams: ForcedShiftParam[] =
      Object.values(values?.forcedShifts || {})?.map((d: any) => {
        return {
          provider_type: d.providerType,
          shift_length: d.shiftLength,
          shift_start: getUTCDateTime(d.startDate),
        };
      }) || [];
    const params = {
      client_id: sessionId,
      version_id: values?.versionId,
      facility_app_shift_length:
        Array.isArray(values?.appShiftLength) &&
        values.appShiftLength.length > 0
          ? values?.appShiftLength
          : undefined,
      facility_physician_shift_length:
        Array.isArray(values?.phyShiftLength) &&
        values?.phyShiftLength.length > 0
          ? values?.phyShiftLength
          : undefined,
      cube_start_date: startDate,
      cube_end_date: endDate,
      patient_volume_flag: values?.enableOverrideValue,
      base_line_flag: values?.baselineEnableOverrideValue,
      patient_volume:
        values?.patientVolume !== '' && values?.enableOverrideValue
          ? Number(values?.patientVolume)
          : undefined,
      app_patients_per_hour:
        values?.appCasesHrBaseline !== '' && values?.baselineEnableOverrideValue
          ? Number(values?.appCasesHrBaseline)
          : undefined,
      physician_patients_per_hour:
        values?.phyCasesHrBaseline !== '' && values?.baselineEnableOverrideValue
          ? Number(values?.phyCasesHrBaseline)
          : undefined,
      shift_start_time:
        values?.shiftStartTime !== ''
          ? Number(values?.shiftStartTime)
          : undefined,
      pct_cases_app_auto:
        Object.keys(pctCasesAppAuto)?.length > 0 ? pctCasesAppAuto : undefined,
      pct_cases_app_shared:
        Object.keys(pctCasesAppShared)?.length > 0
          ? pctCasesAppShared
          : undefined,
      forced_shift_data: changedShiftsParams,
    };
    try {
      setIsPopoverOpen(false);
      facilityDispatch(
        facilityActions.updateFacilityWiseGraphStatus(
          selectedFacility,
          GRAPH_GENERATE_STATUS.IN_PROGRESS_GENERATE_GRAPH
        )
      );

      sendMessage(
        {
          type: 'userparam',
          userparam: params,
          facility: selectedFacility,
        },
        (err, response) => {
          if (err) {
            console.error('WS Data Error 💥', err);
            facilityDispatch(
              facilityActions.updateFacilityWiseGraphStatus(
                selectedFacility,
                GRAPH_GENERATE_STATUS.ERROR_GENERATE_GRAPH
              )
            );
          } else if (response?.status?.toLowerCase?.() === 'start')
            facilityDispatch(
              facilityActions.updateFacilityWiseGraphStatus(
                selectedFacility,
                GRAPH_GENERATE_STATUS.IN_PROGRESS_GENERATE_GRAPH
              )
            );
        },
        30000
      );
      // facilityDispatch(
      //   facilityActions.setSelectedParamVersionId(
      //     selectedFacility,
      //     values?.versionId || ''
      //   )
      // );
      // dashboardDispatch(
      //   dashboardActions.setSelectedParamVersion(currentParamVersion)
      // );
    } catch (error) {
      facilityDispatch(
        facilityActions.updateFacilityWiseGraphStatus(
          selectedFacility,
          GRAPH_GENERATE_STATUS.ERROR_GENERATE_GRAPH
        )
      );
      console.error('API ERROR 💥💥💥', error);
    }
  };
  // const form = useForm(initialState, validationRule, hanldeSubmit);
  // const { reset } = form;

  const { data: activeGraphParams = {} } = useGraphApiDataRevalidator(
    END_POINTS.SOT.getUserParams(selectedFacility)
  );
  const activeVersion = activeGraphParams?.version_id
    ? activeGraphParams?.version_id?.toLowerCase() === 'default'
      ? ''
      : activeGraphParams?.version_id
    : '';

  const navigate = useNavigate();
  const location = useLocation();
  const [openAlert, setOpenAlert] = useState<
    'resetAlert' | 'generateAlert' | 'generateErrorAlert' | false
  >(false);
  const [isOpenManageShift, setIsOpenManageShift] = useState<boolean>(false);
  const [prevFirstTimeSuccessGenerate, setPrevFirstTimeSucessGenerate] =
    useState(false);
  const [prevFirstTimeErrorGenerate, setPrevFirstTimeErrorGenerate] =
    useState(false);
  const firstTimeSuccessGenerate =
    activeFacilitySnapShot.userGraphGenerationStatus ===
    GRAPH_GENERATE_STATUS.SUCCESS_GENERATE_GRAPH;
  const firstTimeErrorGenerate =
    activeFacilitySnapShot.userGraphGenerationStatus ===
    GRAPH_GENERATE_STATUS.ERROR_GENERATE_GRAPH;

  if (prevFirstTimeSuccessGenerate !== firstTimeSuccessGenerate) {
    setPrevFirstTimeSucessGenerate(firstTimeSuccessGenerate);
    if (firstTimeSuccessGenerate) setOpenAlert('generateAlert');
  }

  if (prevFirstTimeErrorGenerate !== firstTimeErrorGenerate) {
    setPrevFirstTimeErrorGenerate(firstTimeErrorGenerate);
    if (firstTimeErrorGenerate) setOpenAlert('generateErrorAlert');
  }

  const isApplyGeneratedGraph = !!(
    activeFacilitySnapShot.userGraphGenerationStatus ===
    GRAPH_GENERATE_STATUS.SUCCESS_GENERATE_GRAPH
  );

  const isGraphGenerating = !!(
    activeFacilitySnapShot.userGraphGenerationStatus ===
    GRAPH_GENERATE_STATUS.IN_PROGRESS_GENERATE_GRAPH
  );

  const onAlertOk = async () => {
    setOpenAlert(false);
    if (openAlert === 'generateAlert') {
      dashboardDispatch(
        dashboardActions.setScenarios({
          data: [],
          isLoading: false,
        })
      );
      facilityDispatch(
        facilityActions.updateFacilityWiseGraphStatus(
          selectedFacility,
          GRAPH_GENERATE_STATUS.APPLY_GENERATED_GRAPH,
          sessionId as string
        )
      );
    } else if (openAlert === 'resetAlert') {
      try {
        if (activeFacilitySnapShot?.shiftSessionId) {
          await DashboardService.reset({
            user_id: activeFacilitySnapShot.shiftSessionId,
            facility_code: selectedFacility,
          });
        }
      } catch (error) {
        console.error('API Error : 💥💥💥', error);
      }
      dashboardDispatch(
        dashboardActions.setScenarios({ data: [], isLoading: false })
      );
      dashboardDispatch(dashboardActions.setSelectedDay(0));
      // dashboardDispatch(dashboardActions.setSelectedParamVersion(''));
      facilityDispatch(
        facilityActions.updateFacilityWiseGraphStatus(
          selectedFacility,
          GRAPH_GENERATE_STATUS.DEFAULT_GENERATE_GRAPH
        )
      );
      // facilityDispatch(
      //   facilityActions.setSelectedParamVersionId(selectedFacility, '')
      // );

      // patchUserParam(defaultUserParamData);
    } else if (openAlert === 'generateErrorAlert') {
      facilityDispatch(
        facilityActions.updateFacilityWiseGraphStatus(
          selectedFacility,
          GRAPH_GENERATE_STATUS.IDLE_GENERATED_GRAPH
        )
      );
    }
  };
  const onAlertCancel = () => {
    setOpenAlert(false);
    if (openAlert === 'generateErrorAlert') {
      facilityDispatch(
        facilityActions.updateFacilityWiseGraphStatus(
          selectedFacility,
          GRAPH_GENERATE_STATUS.IDLE_GENERATED_GRAPH
        )
      );
    }
  };
  const onAlertClose = () => {
    setOpenAlert(false);
    if (openAlert === 'generateErrorAlert') {
      facilityDispatch(
        facilityActions.updateFacilityWiseGraphStatus(
          selectedFacility,
          GRAPH_GENERATE_STATUS.IDLE_GENERATED_GRAPH
        )
      );
    }
  };
  const triggerManageShift = () => {
    setIsOpenManageShift(true);
  };

  return (
    <>
      {!!openAlert && (
        <AlertDialog
          open={!!openAlert}
          onOk={onAlertOk}
          onCancel={onAlertCancel}
          onClose={onAlertClose}
          title={
            openAlert === 'generateErrorAlert'
              ? 'Something went wrong!'
              : 'Are you sure?'
          }
          desc={ALERT_DESC?.[openAlert] || ''}
          showCancelButton={openAlert !== 'generateErrorAlert'}
        />
      )}
      <PdfViewerModal
        open={isOpenPdfViewer}
        onClose={() => {
          setIsOpenPdfViewer(false);
        }}
      />
      {selectedScenario && (
        <ShiftControllerModal
          open={isOpenManageShift}
          onClose={() => {
            setIsOpenManageShift(false);
          }}
        />
      )}
      <Grid container spacing={1.5}>
        <Grid item xl={4} lg={4} md={4} xs={12}>
          <Stack direction="row" spacing={0.5} sx={{ height: '3rem' }}>
            {!(
              location.pathname === '/dashboard' || location.pathname === '/'
            ) && (
              <ArrowBackIosNewIcon
                sx={{ height: '100%', cursor: 'pointer' }}
                onClick={() => navigate('/')}
              />
            )}
            <DashboardTypography>{TEXT_CONTENT.DASHBOARD}</DashboardTypography>
          </Stack>
        </Grid>
        <Grid item xl={8} lg={8} md={8} xs={12}>
          <Box
            sx={{
              display: 'flex',
              flexFlow: 'row wrap',

              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: '0.5rem',
              height: '100%',
              '> *': {
                height: '100%',
                maxHeight: '3rem',
                // width: 'fit-content',
                flex: '0 1 auto',
              },
              '.MuiDivider-vertical': {
                flex: 0,
                height: '3ch',
              },
            }}
          >
            <Button
              variant="outlined"
              disabled={!selectedScenario}
              onClick={() => {
                setIsOpenPdfViewer(true);
              }}
            >
              {TEXT_CONTENT.EXPORT_TO_PDF}
            </Button>
            <Button
              variant="outlined"
              endIcon={<RefreshIcon />}
              onClick={() => {
                setOpenAlert('resetAlert');
              }}
            >
              <ResetTypography>{TEXT_CONTENT.RESET}</ResetTypography>
            </Button>
            <StyledDivider orientation="vertical" flexItem />
            <Dropdown
              id="toolbar-facility-selector"
              options={
                facilityList?.map?.((d: any) => ({
                  id: d,
                  name: d,
                })) || []
              }
              sx={{ maxWidth: '25ch', width: '100%', height: '100%' }}
              fullWidth
              value={selectedFacility}
              label={TEXT_CONTENT.SELECT_A_FACILITY}
              onChange={(value) =>
                facilityDispatch({
                  type: FACILITY_ACTION_TYPES.SET_SELECTED_FACILITY,
                  payload: value,
                  currentFacilitySnapshot: {
                    [selectedFacility]: dashboardState,
                  },
                })
              }
            />

            <StyledDivider orientation="vertical" flexItem />
            {isApplyGeneratedGraph && (
              <>
                <Button
                  color="primary"
                  variant="contained"
                  style={{
                    height: '100%',
                    textAlign: 'center',
                  }}
                  onClick={() => {
                    setOpenAlert('generateAlert');
                  }}
                >
                  {TEXT_CONTENT.APPLY_SCHEDULE}
                </Button>
                <StyledDivider orientation="vertical" flexItem />
              </>
            )}
            <Button
              color="primary"
              variant="contained"
              style={{
                height: '100%',
                textAlign: 'center',
              }}
              disabled={isScenarioLoading || !selectedScenario}
              onClick={triggerManageShift}
            >
              {TEXT_CONTENT.MANAGE_SHIFT}
            </Button>
            <StyledDivider orientation="vertical" flexItem />
            <BasicPopover
              open={isPopoverOpen}
              onChange={(v) => {
                setIsPopoverOpen(v);
                // if (!v) setCurrentParamVersion(prevParamVersion);
              }}
              element={
                <UserParamChooser
                  disabled={isGraphGenerating}
                  onCancel={() => {
                    setIsPopoverOpen(false);
                  }}
                  key={activeVersion}
                  activeVersion={activeVersion}
                  activeGraphParams={activeGraphParams}
                  onSubmit={handleInputParameterSubmit}
                />
              }
              sx={{ maxWidth: '18rem', width: '100%' }}
            >
              {isGraphGenerating ? (
                <Button
                  color="primary"
                  variant="contained"
                  sx={{ width: '100%', height: '100%' }}
                  startIcon={
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        animation: 'spin 2s linear infinite',
                        '@keyframes spin': {
                          '0%': {
                            transform: 'rotate(360deg)',
                          },
                          '100%': {
                            transform: 'rotate(0deg)',
                          },
                        },
                      }}
                    >
                      <GenerateNewIcon height="1.7rem" width="1.7rem" />
                    </Box>
                  }
                >
                  {TEXT_CONTENT.GENERATING_NEW_SCHEDULE}
                </Button>
              ) : (
                <Button
                  color="primary"
                  variant="contained"
                  sx={{ width: '100%', height: '100%' }}
                  startIcon={
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <GenerateNewIcon height="1.7rem" width="1.7rem" />
                    </Box>
                  }
                  disabled={isScenarioLoading}
                >
                  {TEXT_CONTENT.GENERATE_NEW_SCHEDULE}
                </Button>
              )}
            </BasicPopover>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

export default Toolbar;

// const initialState = {
//   enableOverrideValue: false,
//   baselineEnableOverrideValue: false,
//   patientVolume: '',
//   arrivalCubeData: ['', ''],
//   appCasesHrBaseline: '',
//   phyCasesHrBaseline: '',
//   appShiftLength: [],
//   phyShiftLength: [],
//   shiftStartTime: '',
//   pctCasesAppAuto: {
//     '99281': '',
//     '99282': '',
//     '99283': '',
//     '99284': '',
//     '99285': '',
//     '99291': '',
//   },
//   pctCasesAppShared: {
//     '99281': '',
//     '99282': '',
//     '99283': '',
//     '99284': '',
//     '99285': '',
//     '99291': '',
//   },
//   forcedShifts: {},
// };

// const validationRule: FormValidationRules = {
//   arrivalCubeData: (value) => {
//     if (
//       Array.isArray(value) &&
//       value.length > 1 &&
//       value.some((d) => isValidDate(d))
//     ) {
//       if (!value.every((d) => isValidDate(d))) return 'Invalid Date Range';
//       let newDateVal = value.map((d) => new Date(d)?.valueOf());
//       const diffDays = Math.ceil(
//         dateDiffCheck(
//           new Date(newDateVal[1]).toISOString(),
//           new Date(newDateVal[0]).toISOString()
//         )
//       );
//       if (diffDays < 0) {
//         return "From date can't go beyond To date";
//       } else if (diffDays >= 0 && diffDays < 6) {
//         return 'Date range must have atleast 7 days gap';
//       }
//       return undefined;
//     }
//     return undefined;
//   },
// };

const ALERT_DESC = {
  generateAlert:
    'The new generated schedule is ready. Do you want to apply new data to all graphs?',
  resetAlert:
    'You are going to make all graphs data based on default schedule.',
  generateErrorAlert:
    'Something went wrong while generating schedule. Please try again.',
};
